import { getLeftNavGroupFoldersStore } from '../store/store';
import { GroupFolderWellKnownName } from 'owa-folders-constants';

/**
 * @param groupId Smtp address of the group
 * @returns Boolean value whether there are user created folders for the specified group
 */
export function hasUserCreatedFolders(groupId: string): boolean {
    let retVal = false;
    if (!groupId) {
        return retVal;
    }
    const folderHierarchy = getLeftNavGroupFoldersStore().folderTable.get(groupId.toLowerCase())
        ?.folderHierarchy;
    if (folderHierarchy) {
        for (const groupFolder of folderHierarchy.values()) {
            const wellknownName = groupFolder.WellKnownName?.toLowerCase();
            // TODO, optimize by creating map of [WellKnownName][FolderId]
            // TODO Incorporate parallel folder support once platform provides it
            if (
                wellknownName === GroupFolderWellKnownName.INBOX &&
                groupFolder.ChildFolderCount > 0
            ) {
                retVal = true;
                break;
            }
        }
    }
    return retVal;
}
